import { FilterTrait } from 'src/models/SessionFilters';

import { FilterOption } from '../types';
import { getFilterName, getFilterValue } from '../utils';

import FilterChip from './FilterChip';
import { Wrapper, ClearButtonWrapper } from './styles';

const filterKey = (f: FilterOption) => `${f.trait}:${getFilterValue(f)}`;

const AllSelectedFilters: React.FC<{
  filters: FilterOption[];
  lockedFilterKeys: Set<string>;
  hideLockedFilterChips: boolean;
  onClearFilter: (item: FilterOption, index: number) => void;
  clearAllButton: JSX.Element;
}> = ({
  filters,
  lockedFilterKeys,
  hideLockedFilterChips,
  onClearFilter,
  clearAllButton,
}) => {
  const visibleFilters = filters.filter((f) => {
    if (f.trait === FilterTrait.Phrase) {
      return false;
    }
    if (hideLockedFilterChips && lockedFilterKeys.has(filterKey(f))) {
      return false;
    }
    return true;
  });
  const hasRemovableVisible = visibleFilters.some((f) => !lockedFilterKeys.has(filterKey(f)));
  return (
    <Wrapper>
      {visibleFilters.map((filter) => {
        const originalIndex = filters.indexOf(filter);
        const locked = lockedFilterKeys.has(filterKey(filter));
        return (
          <FilterChip
            key={filterKey(filter)}
            label={getFilterName(filter)}
            removable={!locked}
            onRemove={() => onClearFilter(filter, originalIndex)}
          />
        );
      })}
      {hasRemovableVisible && (
        <ClearButtonWrapper>
          {clearAllButton}
        </ClearButtonWrapper>
      )}
    </Wrapper>
  );
};

export default AllSelectedFilters;
